"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SimpleAPIResponse_1 = require("./SimpleAPIResponse");
/**
 * A class that can parse a JSON response into a SimpleAPIResponse
 */
var SimpleAPIParser = /** @class */ (function () {
    function SimpleAPIParser() {
    }
    /**
     * Resolve a SimpleAPI payload response
     * @param payload the payload retrieved from an API call
     * @param attributesOnly {boolean} True if the payload only contains attributes
     * @returns {SimpleAPIResponse} a collection of objects.
     */
    SimpleAPIParser.prototype.resolve = function (payload, attributesOnly) {
        if (attributesOnly === void 0) { attributesOnly = false; }
        var response = new SimpleAPIResponse_1.SimpleAPIResponse();
        if (attributesOnly) {
            payload = { data: [payload] };
        }
        response.setResponse(payload);
        return response;
    };
    /**
     * Resolve a set of bulk responses
     * @param payload {any}
     * @returns {SimpleAPIResponse[]}
     */
    SimpleAPIParser.prototype.resolveBulk = function (payload) {
        var responses = [];
        if (payload.hasOwnProperty("bulk") && Array.isArray(payload.bulk)) {
            for (var i in payload.bulk) {
                if (payload.bulk.hasOwnProperty(i)) {
                    responses.push(this.resolve(payload.bulk[i]));
                }
            }
        }
        return responses;
    };
    return SimpleAPIParser;
}());
exports.SimpleAPIParser = SimpleAPIParser;
exports.SimpleAPIParserSingleton = new SimpleAPIParser();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2ltcGxlQVBJUGFyc2VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL0FQSS9TaW1wbGVBUEkvU2ltcGxlQVBJUGFyc2VyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEseURBQXdEO0FBRXhEOztHQUVHO0FBQ0g7SUFBQTtJQW1DQSxDQUFDO0lBbENDOzs7OztPQUtHO0lBQ0ksaUNBQU8sR0FBZCxVQUNFLE9BQVksRUFDWixjQUErQjtRQUEvQiwrQkFBQSxFQUFBLHNCQUErQjtRQUUvQixJQUFNLFFBQVEsR0FBc0IsSUFBSSxxQ0FBaUIsRUFBRSxDQUFDO1FBQzVELElBQUksY0FBYyxFQUFFO1lBQ2xCLE9BQU8sR0FBRyxFQUFFLElBQUksRUFBRSxDQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUM7U0FDL0I7UUFDRCxRQUFRLENBQUMsV0FBVyxDQUFDLE9BQU8sQ0FBQyxDQUFDO1FBQzlCLE9BQU8sUUFBUSxDQUFDO0lBQ2xCLENBQUM7SUFFRDs7OztPQUlHO0lBQ0kscUNBQVcsR0FBbEIsVUFBbUIsT0FBTztRQUN4QixJQUFNLFNBQVMsR0FBd0IsRUFBRSxDQUFDO1FBQzFDLElBQUksT0FBTyxDQUFDLGNBQWMsQ0FBQyxNQUFNLENBQUMsSUFBSSxLQUFLLENBQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsRUFBRTtZQUNqRSxLQUFLLElBQU0sQ0FBQyxJQUFJLE9BQU8sQ0FBQyxJQUFJLEVBQUU7Z0JBQzVCLElBQUksT0FBTyxDQUFDLElBQUksQ0FBQyxjQUFjLENBQUMsQ0FBQyxDQUFDLEVBQUU7b0JBQ2xDLFNBQVMsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztpQkFDL0M7YUFDRjtTQUNGO1FBQ0QsT0FBTyxTQUFTLENBQUM7SUFDbkIsQ0FBQztJQUNILHNCQUFDO0FBQUQsQ0FBQyxBQW5DRCxJQW1DQztBQW5DWSwwQ0FBZTtBQXFDZixRQUFBLHdCQUF3QixHQUFHLElBQUksZUFBZSxFQUFFLENBQUMifQ==